import { createFileRoute, redirect } from '@tanstack/react-router';
import { FormattedMessage } from 'react-intl';

import { preLoadDefaultProject } from '@/lib/queries/project';

import { WelcomeCard } from './-components/WelcomeCard';

export const Route = createFileRoute('/_root/getting-started/')({
  component: RouteComponent,
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({ id: 'global.menu.gettingStarted' }),
  }),
  loader: async ({ context }) => {
    const defaultProject = await preLoadDefaultProject({ context });

    if (defaultProject.slackWorkspaceName !== undefined) {
      throw redirect({
        to: '/getting-started/slack-channels',
      });
    }

    return defaultProject;
  },
});

function RouteComponent() {
  return (
    <div className="container mx-auto mt-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
            <FormattedMessage id="gettingStarted.index.welcome.title" />
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            <FormattedMessage id="gettingStarted.index.welcome.subtitle" />
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
          <WelcomeCard />
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            <FormattedMessage id="gettingStarted.index.support.text" />{' '}
            <a
              href="mailto:support@anyshift.io"
              className="text-blue-500 hover:text-blue-600"
            >
              support@anyshift.io
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
